var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.12305C0.5 0.957287 0.565848 0.798315 0.683058 0.681105C0.800268 0.563895 0.95924 0.498047 1.125 0.498047H14.8783C14.9944 0.498047 15.1082 0.530369 15.2069 0.59139C15.3056 0.652412 15.3854 0.739722 15.4373 0.843538C15.4893 0.947355 15.5112 1.06357 15.5008 1.17918C15.4904 1.29478 15.448 1.40519 15.3783 1.49805L11.9083 6.12388L15.3783 10.7505C15.448 10.8434 15.4904 10.9538 15.5008 11.0694C15.5112 11.185 15.4893 11.3012 15.4373 11.4051C15.3854 11.5089 15.3056 11.5962 15.2069 11.6572C15.1082 11.7182 14.9944 11.7505 14.8783 11.7505H1.75V15.708C1.74999 15.8591 1.6953 16.005 1.59603 16.1188C1.49676 16.2326 1.35963 16.3067 1.21 16.3272L1.125 16.3339C0.973969 16.3339 0.828048 16.2792 0.714224 16.1799C0.600401 16.0806 0.526374 15.9435 0.505833 15.7939L0.5 15.708V1.12305Z",
    fill: "#8592AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.3ace52815308eda03b9e64a3f292388e.svg";
export { ForwardRef as ReactComponent };